import { useState } from "react";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { Link, useParams } from "react-router-dom";

/**
 * Upiupload component displays a success message after UPI details submission.
 * Provides navigation to bank/pancard details page.
 */
const Upiupload = ({ login = null }) => {

  const { userId } = useParams();
  const [redirectUrl] = useState(login ? 'customer' : 'customerCard')
  return (
    <>
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-6 mt-10 pancard-data">
            <div className="text-center mb-7">
              <img
                width="300"
                alt="icon"
                src={toAbsoluteUrl("/media/images/pan-success.png")}
              />
            </div>
          </div>

          <div className="col-md-6 mt-10 pancard-data">
            <div className="mt-15">
              <h1 className="mb-5">Success</h1>
              <p>Your UPI details has been successfully Submitted</p>
              <div className="btns cn-btn mt-15 d-flex">
                <Link to={`/${redirectUrl}/bankpancard-details/${userId}`}>
                  <button className="btn red-btn text-white">OK</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Upiupload;
